import { AxiosInstance, HttpStatusCode, InternalAxiosRequestConfig } from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import jwt from 'jsonwebtoken';
import {
  getAccessTokenFromCookies,
  getRefreshTokenFromCookies,
  logout,
  setAccessTokenToCookies,
  setRedirectUrlToCookies,
  setRefreshTokenToCookies,
  unsetTokensFromCookies,
} from './auth';
import { REDIRECT_URL, REQUEST_URLS } from './constants';
import { getAxiosInstance, getDefaultAccountId, getLoginPath, getPublicPaths } from './setup';

export const goToLoginWithRedirect = () => {
  logout();
  const redirectPathAndSearch = window.location.pathname + window.location.search;
  setRedirectUrlToCookies(REDIRECT_URL, redirectPathAndSearch);
  window.location.pathname = getLoginPath();
};

export const accessTokenInterceptor = (request: InternalAxiosRequestConfig) => {
  const token = getAccessTokenFromCookies();
  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }
  const currentAccountId = JSON.parse(localStorage.getItem('currentAccountId') || '""');
  if (currentAccountId) {
    request.headers['x-fiona-account-id'] = currentAccountId;
  } else {
    const defaultAccountId = getDefaultAccountId();
    if (defaultAccountId) {
      request.headers['x-fiona-account-id'] = defaultAccountId;
    } else {
      const obj = jwt.decode(token) as any;
      const firstAccountId = obj?.accountUsers[0]?.accountId || null;
      if (firstAccountId) {
        request.headers['x-fiona-account-id'] = firstAccountId;
      }
    }
  }
  return request;
};

const refreshAuthLogicInterceptor = async failedRequest => {
  const isInPublicPath = getPublicPaths().includes(window.location.pathname);
  const refreshToken = getRefreshTokenFromCookies();
  const isLoggedOut = !isInPublicPath && !refreshToken;
  if (isLoggedOut) {
    goToLoginWithRedirect();
  }
  try {
    const tokenRefreshResponse = await getAxiosInstance().post(REQUEST_URLS.AUTH_REFRESH, {
      refreshToken,
    });
    const newToken = tokenRefreshResponse.data;
    setAccessTokenToCookies(newToken.accessToken);
    setRefreshTokenToCookies(newToken.refreshToken);
    failedRequest.response.config.headers.Authorization = `Bearer ${getAccessTokenFromCookies()}`;
  } catch (err) {
    unsetTokensFromCookies();
    // TODO: Do we need to check if this is a 401 error? Or simply redirect to login
    if (err?.response?.status === HttpStatusCode.Unauthorized && !isInPublicPath) {
      goToLoginWithRedirect();
    }
  }
};

export function addAuthRefreshInterceptorToAxios(axiosInstance: AxiosInstance) {
  createAuthRefreshInterceptor(axiosInstance, refreshAuthLogicInterceptor, {
    statusCodes: [HttpStatusCode.Unauthorized],
  });
}
